import Config from '../config/config';
import _ from 'lodash';
import React from 'react';
import { UseEvent } from './index';
import Api from '../api';

export default  function UsePayment() {
  const event = UseEvent()
  const getCards = async (type, loader) => {
    const getBogCards = () => {
      return new Promise(resolve => {
        Api.Payments.getCards({
          url: Config.Payment[type].Cards.Bog,
          loader: loader
        }).then(response => {
           resolve(response.status? response?.data?.data?.cards:[])
        })
      })
    }
    const getTbcCards = () => {
      return new Promise(resolve => {
        Api.Payments.getCards({
          url: Config.Payment[type].Cards.Tbc,
          loader: loader
        }).then(response => {
          resolve(response.status? type==="withdraw"? response?.data?.items: response?.data?.data?.cards:[])
        })
      })
    }
    const response =  await Promise.all([getBogCards(), getTbcCards()])
    return _.size(response)>0?_.flatMap(response):[]
  }

  const frame=({
    onCancel,
    children,
    variant="dark",
    outsideDismiss=true,
    closeButton=true,
    size="md",
    fullscreen="none",
    callback,
    frameListener,
    content,
    })=>{

    event.emit(
      "lb-event",
      {
        type:'Frame',
        outsideDismiss:outsideDismiss,
        variant:variant,
        onCancel:onCancel,
        children: children,
        closeButton:closeButton,
        size:size,
        fullscreen:fullscreen,
        callback:callback,
        frameListener:frameListener,
        content
      }
    )
  }


  const deposit =({vendor,cardid,amount,saveCard,loader,additionalParams={}})=>{

     return Api.Payments.deposit({
        url:vendor==="bog"?Config.Payment.deposit.Bog:Config.Payment.deposit.Tbc,
        params:{
          vendor: vendor,
          cardid: cardid,
          amount: amount,
          saveCard:saveCard,
          ...additionalParams
        },
        loader:loader
      })


  }
  const withdraw =({vendor,cardid,amount,loader,sms,additionalParams={}})=>{
    console.log({vendor,cardid,amount,loader,sms})
    let url="";
    let params = {}

    switch (vendor){
      case "bog":
        url=Config.Payment.withdraw.Bog;
        params={...params,
          vendor: "bog_bank",
          card: cardid,
          amount: amount
        }
        if(sms){
          params["sms_code"]=sms;
        }
        break;
      case "tbc":
        url=Config.Payment.withdraw.Tbc;
        params={...params,
          vendor: "tbc_card",
          card: cardid,
          amount: amount
        }
        if(sms){
          params["sms_code"]=sms;
        }
       break;
      case "leader_card":
       url=Config.Payment.withdraw.Nbc.pay;
        params={...params,
          vendor: "nbs",
          sync: cardid?1:0,
          amount: amount,
          money: amount
        }
        if(sms){
          params["sms_code"]=sms;
        }
        break;
      case "emoney":
        url=Config.Payment.withdraw.Emoney;
        params={...params,
          vendor: "emoney",
          vendor_username:cardid,
          money: amount

        }
        if(sms){
          params["sms_code"]=sms;
        }
        break;
      case "allpayway":
      /* vendor: emoney
       money: 1
       sms_code: 1*/
        url=Config.Payment.withdraw.AllPayWay;
       params={...params,
         vendor: "allpayway",
         money: amount
       }
       if(sms){
         params["sms_code"]=sms;
       }
      break;
    }


    return Api.Payments.withdraw({
        url:url,
        params:params,
        loader:loader
      })
  }

  const submitForm = (url, transId) =>{
    const form = document.createElement("form");
    const element1 = document.createElement("input");
    form.target="paymentIframe"
    form.method = "GET";
    form.action = url;
    element1.type="hidden";
    element1.name="trans_id";
    element1.value=transId;
    form.appendChild(element1);
    document.body.appendChild(form);
    form.submit();
    form.remove()
  }
  return { getCards,frame,deposit,submitForm,withdraw }
}
